import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { UserService } from "@app/services/user.service";
import { Observable, from } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root", // Ensuring singleton service and tree-shakable
})
export class OrderSheetGuardService {
  constructor(private userService: UserService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    // Convert the Promise returned by hasAccess into an Observable
    return from(this.userService.hasAccess("order-sheet")).pipe(
      map((hasAccess) => {
        if (!hasAccess) {
          // Perform a full redirect if no access
          window.location.href = "/request-invite/order-sheet";
        }
        return hasAccess; // Return the access status
      })
    );
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    // Reuse canActivate for child routes
    return this.canActivate(route, state);
  }
}
